export default __webpack_public_path__ + "static/media/hazard_alt.9ee68ca1.svg";